/**
 * The one email sanity check the purchase flow uses.
 *
 * Extracted from `PurchaseFlowRevamp/store/selectors.ts`, where it was private
 * to the billing gate, because the Instructions gate now applies the same rule
 * to the meeting contact email AND its form field wants to render the matching
 * error. Three copies of a regex is how a field and its gate end up disagreeing
 * about what "valid" means.
 *
 * Deliberately loose (no punycode / IDN): it exists to catch a typo before the
 * step advances, not to be RFC-5322 complete. The backend remains the authority.
 */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
